export const DETECTIVE_HIRING_TIME = 40 * 60; // 40 minutes

export const DETECTIVE_BASE_COST = 15000; // 15000 IN GAME Cash

export const DETECTIVE_UPDATE_DELAY = 12 * 60 * 60; // 12 hours